import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';

import { useGetElearningQuery, useGetFramesQuery } from '@/modules/services';
import { ElearningParamType } from '@/pages/Module/routes';

import ModuleView from './ModuleView';

const Module = (): ReactElement => {
  const handleError = useErrorHandler();

  const { elearningId } = useParams<ElearningParamType>();

  const elearning = useGetElearningQuery(elearningId);
  const frames = useGetFramesQuery({ elearningId });

  if (elearning.isError) {
    handleError(elearning.error);
  }
  if (frames.isError) {
    handleError(frames.error);
  }

  if (elearning.isLoading || frames.isLoading) {
    return <div className="loading" />;
  }

  return <ModuleView />;
};

export default Module;
